import React from 'react';
import { ArrowUpRight, BadgeCheck } from 'lucide-react';

const Partners = () => {
  const partners = [
    {
      id: 1,
      name: 'SCHÖNOX',
      type: 'Spachtelmassen & Estriche',
      description: 'Premium Partner für Untergrundvorbereitung',
      logo: '/images/partners/schoenox.png',
      website: 'https://deu.sika.com/schoenox/de.html',
      logoClass: 'max-h-14 max-w-[85%]',
      accent: 'bg-[#e4003a]'
    },
    {
      id: 2,
      name: 'Schlüter-Systems',
      type: 'Verlegesysteme',
      description: 'Zertifizierter Partner für Abdichtung & Profile',
      logo: '/images/partners/schlueter-systems.svg',
      website: 'https://eu.schluter.com/de-DE/',
      logoClass: 'max-h-20 max-w-[72%]',
      accent: 'bg-[#f78d1f]'
    },
    {
      id: 3,
      name: 'wedi',
      type: 'Fliesenverlegematerialien',
      description: 'Exklusiver Partner für Verlegetechnik',
      logo: '/images/partners/wedi.svg',
      website: 'https://www.wedi.net/de/',
      logoClass: 'max-h-12 max-w-[72%]',
      logoBackground: 'bg-[#008bd2]',
      accent: 'bg-[#008bd2]'
    },
    {
      id: 4,
      name: 'SIKA',
      type: 'Abdichtung & Kleber',
      description: 'Autorisierter Fachbetrieb für Bauchemie',
      logo: '/images/partners/sika.svg',
      website: 'https://deu.sika.com/de/startseite.html',
      logoClass: 'max-h-28 max-w-[70%]',
      logoPadding: 'p-2',
      accent: 'bg-[#ffc500]'
    }
  ];

  return (
    <section id="partners" className="relative overflow-hidden bg-[#f7f5f1] py-16 lg:py-24">
      <div className="absolute -right-32 top-0 h-80 w-80 rounded-full bg-primary-100/60 blur-3xl" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-10 max-w-3xl text-center lg:mb-14">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-white px-4 py-2 text-xs font-semibold uppercase tracking-[0.16em] text-primary-800 shadow-sm">
            <BadgeCheck className="h-4 w-4" />
            Bewährte Systeme
          </div>
          <h2 className="font-display text-3xl font-semibold leading-tight text-stone-900 lg:text-5xl">
            Partner & Zertifizierungen
          </h2>
          <p className="mt-5 text-base leading-relaxed text-stone-600 sm:text-lg">
            Vertrauen Sie auf unsere langjährigen Partnerschaften mit führenden Herstellern
            und unsere zertifizierte Qualität.
          </p>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {partners.map((partner) => (
            <a
              key={partner.id}
              href={partner.website}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative flex min-h-full flex-col overflow-hidden rounded-2xl border border-stone-200 bg-white shadow-sm transition duration-300 hover:-translate-y-1 hover:border-stone-300 hover:shadow-xl hover:shadow-stone-900/10"
              aria-label={`${partner.name} Website öffnen`}
            >
              <div className={`h-1.5 w-full ${partner.accent}`} />
              <div className={`flex h-32 items-center justify-center border-b border-stone-100 ${partner.logoPadding || 'p-6'} ${partner.logoBackground || 'bg-white'}`}>
                <img
                  src={partner.logo}
                  alt={`${partner.name} Logo`}
                  loading="lazy"
                  className={`h-auto w-auto object-contain ${partner.logoClass}`}
                />
              </div>

              <div className="flex flex-1 flex-col p-6">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-display text-lg font-semibold text-stone-900">
                    {partner.name}
                  </h3>
                  <span className="rounded-full bg-stone-100 p-2 text-stone-500 transition group-hover:bg-primary-50 group-hover:text-primary-700">
                    <ArrowUpRight className="h-4 w-4" />
                  </span>
                </div>

                <p className="mt-3 text-sm font-semibold text-primary-700">
                  {partner.type}
                </p>
                <p className="mt-2 text-sm leading-relaxed text-stone-500">
                  {partner.description}
                </p>

                <span className="mt-6 inline-flex items-center gap-2 border-t border-stone-100 pt-4 text-xs font-semibold uppercase tracking-[0.13em] text-stone-400 transition group-hover:text-stone-700">
                  Hersteller ansehen
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
